module.exports = __webpack_public_path__ + "images/traffic_light_main_baked.61177da6a111c8400c228e042bf8de40.png";